import { createAsyncThunk } from "@reduxjs/toolkit";
import { protectedApi } from "../../app/utils/common/protectedApi";
import { APIS } from "../../app/utils/constants/apiConstant";

export const getAllProject = createAsyncThunk(
    "project/getAllProject",
    async (_, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.GET_ALL_PROJECT}`,
                method: "GET",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const createProjectAPI = createAsyncThunk(
    "project/createProjectAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.CREATE_PROJECT}`,
                method: "POST",
                data
            });

            return response.data;
        } catch (error) {
            console.log("error in api")
            return rejectWithValue(error.response.data.error);
        }
    }
);


export const updateProjectAPI = createAsyncThunk(
    "project/updateProjectAPI",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.UPDATE_PROJECT.replace(":projectId", id)}`,
                method: "PUT",
                data: payload
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
